<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/about/management',
    'fr-CA': '/a-propos-kpt/direction'
  }
})

useHead({
  title: t('navigation.management.metatitle'),
  meta: [{ name: 'description', content: t('navigation.management.metadescription') }],
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('about-about')">{{ $t('navigation.about.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.management.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.management.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuAbout />
        <div class="contenu right">
          <board-directions :title="$t('boardDirectors.Management.Dino-Bianco.name')"
                            :text="$t('boardDirectors.Management.Dino-Bianco.text')"></board-directions>
          <board-directions :title="$t('boardDirectors.Management.Michael-Keays.name')"
                            :text="$t('boardDirectors.Management.Michael-Keays.text')"></board-directions>
          <board-directions :title="$t('boardDirectors.Management.Francois-Paroyan.name')"
                            :text="$t('boardDirectors.Management.Francois-Paroyan.text')"></board-directions>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
